import {BaseWidget} from "./BaseWidget";
import {UiModalContainer} from "./UiModalContainer";
import {InvoiceApprovalCL} from "./generated/InvoiceApprovalCL";

export class UiTicketFieldAttaches extends BaseWidget {

}

export class UiTicketFieldAttach extends BaseWidget {
	public attachId: number = -1;
	public ticketId: number = -1;
	public openPreviewInModal: boolean = false;
	attachLink_click(ev: Event) {
		ev.preventDefault();
		const opts = {
			ticketId: this.ticketId,
			attachId: this.attachId,
			link: (this.ui.attachLink as unknown as HTMLAnchorElement).href
		};
		const label = "Náhled přílohy " + this.ui.attachLink.innerText;
		if (this.openPreviewInModal) {
			UiModalContainer.open(
				'UiTicketAttachPreview',
				label,
				opts
			);
		} else {
			this.muClear('preview');
			this.muWidgetFromTemplate('preview', 'preview', opts);
		}
	}
	beforeIndex() {
		this.muAppendContent(`<div mu-id="preview">
			<div mu-template="preview" mu-widget="UiTicketAttachPreview"></div>
		</div>`);
	}
}

export class UiTicketAttachPreview extends BaseWidget {
	public attachId: number = -1;
	public ticketId: number = -1;

	protected cl: InvoiceApprovalCL = new InvoiceApprovalCL();
	public link: string = "";
	beforeIndex() {
		this.muAppendContent(`<div mu-id="preview"><div class="jumbotron text-center"><h3>Načítám náhled</h3><progress></progress></div></div>
			<a mu-id="lAttaches" target="_blank" class="btn-icon-size-4 btn-icon icon-before-document-dir">Přejít na přílohy</a>
			<a mu-id="lDownload" target="_blank" class="btn-icon-size-4 btn-icon icon-before-download">Stáhnout přílohu</a>
			<span mu-click="muRemoveSelf" class="btn-icon-size-4 btn-icon icon-before-close">Zavřít náhled</span>
		`);
	}

	async afterIndex() {
		this.ui.preview.innerHTML = await this.cl.getAttachDetail(this.attachId, this.ticketId);
		(this.ui.lAttaches as unknown as HTMLAnchorElement).href = this.link;
	}
}